module.exports = __webpack_public_path__ + "img/32e9dc0.png";